(function () {
  var SECTION_SELECTOR = '.oddit-section-product-grid';

  // Wires up one tab panel's carousel: arrows, indicators, drag-to-scroll.
  // Returns a refresh() the caller invokes once the panel becomes visible —
  // a hidden panel has zero clientWidth, so its controls can't be measured.
  function initCarousel(panel) {
    var track = panel.querySelector('.oddit-section-product-grid__track');
    if (!track) return null;

    var prevBtn = panel.querySelector('.oddit-section-product-grid__nav--prev');
    var nextBtn = panel.querySelector('.oddit-section-product-grid__nav--next');
    var indicatorBar = panel.querySelector('[data-carousel-indicators]');

    // A "page" is one viewport-width of the track, so a dot marks a scroll stop
    // rather than a card — several cards share a page on a wide screen. Arrows
    // step a page as well, which is what keeps them and the dots on one index.
    function getPageMetrics() {
      var pageSize = track.clientWidth;
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var count = 1;
      if (pageSize > 0 && maxScroll > 0) {
        count = Math.ceil(maxScroll / pageSize) + 1;
      }
      return { pageSize: pageSize, maxScroll: maxScroll, count: count };
    }

    function getCurrentPage() {
      var m = getPageMetrics();
      if (m.pageSize <= 0) return 0;
      // The last page is usually a partial width, so it can never round up to
      // its own index — treat "within 2px of the end" as the final page.
      if (m.maxScroll > 0 && track.scrollLeft >= m.maxScroll - 2) return m.count - 1;
      var page = Math.round(track.scrollLeft / m.pageSize);
      return Math.max(0, Math.min(page, m.count - 1));
    }

    function scrollToPage(page) {
      var m = getPageMetrics();
      var clamped = Math.max(0, Math.min(page, m.count - 1));
      // Final page goes to the true end of the track; earlier pages are exact
      // multiples of the width. Card snapping then settles it to a card edge.
      var left = clamped >= m.count - 1 ? m.maxScroll : clamped * m.pageSize;
      track.scrollTo({ left: left, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToPage(getCurrentPage() - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToPage(getCurrentPage() + 1);
      });
    }

    // Sync the active dot and arrow visibility to the current page. Both read the
    // same page index, so an arrow click always advances the dot by exactly one.
    function updateControls() {
      var count = getPageMetrics().count;
      var page = getCurrentPage();

      if (indicatorBar) {
        indicatorBar.querySelectorAll('.oddit-section-product-grid__indicator').forEach(function (dot, i) {
          var active = i === page;
          dot.classList.toggle('oddit-section-product-grid__indicator--active', active);
          if (active) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }

      if (prevBtn) prevBtn.classList.toggle('oddit-section-product-grid__nav--hidden', page <= 0);
      if (nextBtn) nextBtn.classList.toggle('oddit-section-product-grid__nav--hidden', page >= count - 1);
    }

    // The dot count follows the page count, which changes with viewport width, so
    // the bar is rebuilt on resize and when a hidden panel is first shown. One
    // page means nothing to scroll: render no dots at all rather than a lone dot.
    function buildIndicators() {
      if (!indicatorBar) return;
      var count = getPageMetrics().count;
      if (count <= 1) {
        indicatorBar.innerHTML = '';
        return;
      }
      if (indicatorBar.children.length === count) return;

      indicatorBar.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'oddit-section-product-grid__indicator';
        dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
        dot.addEventListener('click', (function (target) {
          return function () {
            scrollToPage(target);
          };
        })(i));
        indicatorBar.appendChild(dot);
      }
    }

    function refresh() {
      buildIndicators();
      updateControls();
    }

    track.addEventListener('scroll', function () {
      requestAnimationFrame(updateControls);
    }, { passive: true });

    // Recompute after layout changes (breakpoint switches, CSS applying late).
    window.addEventListener('resize', function () {
      requestAnimationFrame(refresh);
    });

    refresh();

    // Desktop pointer drag-to-scroll. No-ops where the track isn't a horizontal
    // scroller (e.g. the mobile grid layout) and ignores touch pointers so
    // native touch/momentum scrolling is untouched.
    var DRAG_THRESHOLD = 5;
    var drag = { active: false, startX: 0, startScroll: 0, moved: false, pointerId: null };

    function trackIsScrollable() {
      return track.scrollWidth - track.clientWidth > 1;
    }

    track.addEventListener('pointerdown', function (e) {
      if (e.button !== 0 || e.pointerType === 'touch') return;
      if (!trackIsScrollable()) return;
      drag.active = true;
      drag.moved = false;
      drag.startX = e.clientX;
      drag.startScroll = track.scrollLeft;
      drag.pointerId = e.pointerId;
    });

    track.addEventListener('pointermove', function (e) {
      if (!drag.active) return;
      var dx = e.clientX - drag.startX;
      // Capture only once the press is a real drag — capturing on pointerdown
      // retargets the following click to the track, killing the card links.
      if (!drag.moved) {
        if (Math.abs(dx) <= DRAG_THRESHOLD) return;
        drag.moved = true;
        try { track.setPointerCapture(drag.pointerId); } catch (err) {}
        track.classList.add('oddit-section-product-grid__track--dragging');
      }
      track.scrollLeft = drag.startScroll - dx;
      e.preventDefault();
    });

    function endDrag() {
      if (!drag.active) return;
      drag.active = false;
      track.classList.remove('oddit-section-product-grid__track--dragging');
      if (drag.pointerId != null) {
        if (drag.moved) {
          try { track.releasePointerCapture(drag.pointerId); } catch (err) {}
        }
        drag.pointerId = null;
      }
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    // Swallow the synthetic click that ends a real drag so card links don't
    // navigate when the user was only scrolling.
    track.addEventListener('click', function (e) {
      if (drag.moved) {
        e.preventDefault();
        e.stopPropagation();
        drag.moved = false;
      }
    }, true);

    return refresh;
  }

  function initSection(section) {
    if (!section) return;

    var tabs = section.querySelectorAll('.oddit-section-product-grid__tab');
    var tabsContainer = section.querySelector('.oddit-section-product-grid__tabs');
    var panels = section.querySelectorAll('.oddit-section-product-grid__panel');
    // Desktop sidebar and mobile CTA render the same button twice.
    var ctas = section.querySelectorAll('.oddit-section-product-grid__cta');

    // Every panel is wired once up front; hidden ones simply never scroll.
    var refreshers = [];
    panels.forEach(function (panel) {
      refreshers.push(initCarousel(panel));
    });

    // Scroll the clicked tab to the centre of the slider so a hidden or
    // partially-hidden pill becomes fully visible. No-op when the tabs wrap
    // (desktop) and there's nothing to scroll.
    function centerTab(tab) {
      if (!tabsContainer) return;
      var tabRect = tab.getBoundingClientRect();
      var contRect = tabsContainer.getBoundingClientRect();
      var delta = (tabRect.left - contRect.left) - (contRect.width - tabRect.width) / 2;
      tabsContainer.scrollBy({ left: delta, behavior: 'smooth' });
    }

    // Point the CTA at the collection the open tab is showing.
    function syncCta(tab) {
      if (!tab) return;
      var label = tab.getAttribute('data-tab-button-label');
      var link = tab.getAttribute('data-tab-button-link');
      ctas.forEach(function (cta) {
        var labelEl = cta.querySelector('[data-button-label]');
        if (labelEl && label) labelEl.textContent = label;
        if (link) cta.setAttribute('href', link);
      });
    }

    function activate(index) {
      tabs.forEach(function (t, i) {
        var selected = i === index;
        t.classList.toggle('oddit-section-product-grid__tab--active', selected);
        t.setAttribute('aria-selected', selected ? 'true' : 'false');
      });

      panels.forEach(function (panel, i) {
        if (i === index) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      syncCta(tabs[index]);

      // The panel was zero-width while hidden, so arrow/dot state computed then
      // is meaningless. Recompute now that it has laid out.
      var refresh = refreshers[index];
      if (refresh) requestAnimationFrame(refresh);
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activate(index);
        centerTab(tab);
      });
    });
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });
})();
